import { Routes, Route } from 'react-router-dom';
import Main from './FrontendV2.styles';
import { LegacySideBar, ProtectedRoutes } from './components';
import { pages } from './routes';
import { Calendar, Campaigns, MediaLibrary, Reports, Reporting } from './pages';

export const FrontendV2Pages = () => (
  <Main id="v2">
    <LegacySideBar />
    <Routes>
      <Route element={<ProtectedRoutes />}>
        <Route
          path={pages.Calendar.base}
          element={<Calendar />}
        />
        <Route
          path={pages.MediaLibrary.base}
          element={<MediaLibrary />}
        />
        <Route
          path={`${pages.Campaigns.base}/:id?`}
          element={<Campaigns />}
        />
        <Route
          path={`${pages.Measure.base}/*`}
          element={<Reports />}
        />
        <Route
          path={`${pages.Reporting.base}/*`}
          element={<Reporting />}
        />
      </Route>
    </Routes>
  </Main>
);
